<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
        </div>
      </div>
      
      <b-row>
        <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="md"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
        :busy="isBusy"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(action)="data">
          <div>
            <b-button-group size="sm">
              <b-button variant="success" @click="download(data.item)"
                ><i class="fa fa-download"></i> Download</b-button
              >
              <b-button variant="info" @click="reprocessconfirm(data.item)"
                ><i class="fa fa-refresh"></i> Re-Procesing</b-button
              >
              <b-button variant="danger" @click="deleteblobconfirm(data.item)"
                ><i class="fa fa-trash"></i> Delete</b-button
              >
            </b-button-group>
          </div>
        </template>
        <template v-slot:cell(size)="data">{{
          data.item.size | numFormat("0,0")
        }}</template>
        <template v-slot:cell(createdat)="data">{{
          data.item.createdat | moment("YYYY-MM-DD HH:mm")
        }}</template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isLoading: false,
      isBusy: false,
      showDelConfirm: false,
      showReprocessConfirm: false,
      filter: moment().format("YYYYMMDD"),
      filterOn: [],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "createdat",
        sortDesc: false,
        tablename: "historyupload",
        customQuery: "",
        tgl1: moment().format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        partnerTransactionId: "",
        loan_id: "",
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "filename",
          label: "File Name",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },

        {
          key: "size",
          label: "Size (Bytes)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createdat",
          label: "created On",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        }
      ];
      return fields;
    },
  },
  
  created() {
    // this.data();
  },
  watch:{
    filter(val){
      console.log('val',val)
      this.tblData.customQuery='';
      let str = '';
      if (val){
        str = 'filename=%' + encodeURIComponent(val)+'%';
      }
      this.tblData.customQuery=str;
      this.refresh();
    }
  },
  methods: {
    refresh(){
      this.$refs.table.refresh();
    },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.tblData.total = filteredItems.length
        this.currentPage = 1
      },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    async data() {
      try {
        this.isBusy = true;
        this.tblData.customQuery='';
        let str = '';
        if (this.filter){
          str = 'filename=%' + encodeURIComponent(this.filter)+'%';
        }
        this.tblData.customQuery=str;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await crud.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
      
    },
    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>